// extracted by mini-css-extract-plugin
module.exports = {"container":"SplitScreenComponent_container__7zRnB","leftContainer":"SplitScreenComponent_leftContainer__Vv4n2","rightContainer":"SplitScreenComponent_rightContainer__C3ra8"};